module.exports = __webpack_public_path__ + "static/dario-fe9039d9e57448b17abe3c14b3b686b4.png";